// import { toast } from 'react-toastify'
import { useNavigate } from 'react-router-dom'
import { AuthOrganization } from '../../services/Auth/AuthOrganization'

export const useOrganization = (organization: string) => {
  const navigate = useNavigate()

  const goToPage = (url: string) => {
    navigate(url)
  }

  const doOrganization = async () => {
    const postOrganization = await AuthOrganization(organization)
    if (postOrganization.logged) {
      window.location.href = '/dashboard'
      return
    }
    goToPage('/organizacao')
  }
  return {
    doOrganization,
  }
}
